import Model from './Model';

export default class Car extends Model {
  resource() {
    return 'cars';
  }
}
